module.exports = __webpack_public_path__ + "static/media/get-paid-brisbane.13b43778.png";